import pl from "@locales/public_storefront/pl.json";
import en from "@locales/public_storefront/en.json";

export default { pl, en };
